import { Injectable } from "@angular/core";
import { Http, Headers, URLSearchParams } from "@angular/http";
import 'rxjs/add/operator/toPromise';
import { environment } from "../../environments/environment";
import { AppService } from "../app.service";

@Injectable()

export class DeviceBoardService {

    apiUrl: String;
    jwt: String;
    constructor(private http: Http, private appService: AppService) {
        this.apiUrl = environment.apiUrl;
        this.jwt = appService.getJwt();
    }

    getDeviceBoardList(filterParams: any) {
        const url = this.apiUrl + 'api/cms/device-board/list';
        const headers = new Headers();
        headers.append('X-Authorization', 'Bearer ' + this.jwt);
        headers.append('Content-Type', 'application/json');
        const params = new URLSearchParams();
        params.append("page", filterParams.page);
        params.append("size", filterParams.size);
        const body = JSON.stringify({});
        return this.http.post(url, body, { headers, params })
            .toPromise()
            .then(res => res.json())
            .then(resJson => resJson);
    }

    editDeviceBoard(data: any) {
        const url = this.apiUrl + 'api/cms/device-board/edit';
        const headers = new Headers();
        headers.append('X-Authorization', 'Bearer ' + this.jwt);
        headers.append('Content-Type', 'application/json');
        const body = JSON.stringify(data);
        return this.http.post(url, body, { headers })
            .toPromise()
            .then(res => res.json())
            .then(resJson => resJson);
    }

}


// WEBPACK FOOTER //
// /build/client-cms/src/app/device-board/device-board.service.ts